import { SvgIcon, SvgIconProps } from '@mui/material';

export const AlianzasIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox='0 0 96 96'>
		<path
			fill='currentColor'
			stroke='none'
			d='
        M38.793327,76.680412
          C39.264004,77.151016 39.716316,77.641838 40.208389,78.088890
          C43.003017,80.627815 46.096062,81.632164 48.990742,78.586319
          C52.228817,75.179146 48.046581,73.840530 46.643734,71.790047
          C45.274185,69.788239 42.194588,68.698563 43.239605,64.465622
          C46.577183,67.643364 49.333408,70.441109 52.280251,73.021133
          C54.869789,75.288338 57.860886,75.517090 60.336487,73.006752
          C62.994671,70.311264 60.249340,68.563416 58.653038,66.789772
          C57.318417,65.306885 55.796242,63.992489 54.466385,62.505745
          C53.650436,61.593536 52.304790,60.666565 54.031342,58.737556
          C58.101280,60.978432 60.762779,64.878265 64.046043,68.015434
          C66.210968,70.084038 68.436012,71.479042 70.926811,69.040428
          C73.399132,66.619896 72.916931,63.996841 70.464859,61.639469
          C66.745285,58.063553 62.612530,54.796783 59.477139,50.760311
          C53.870132,43.541897 47.733475,39.859287 38.880215,44.995895
          C38.741291,45.076496 38.563000,45.095402 38.399998,45.127453
          C33.022205,46.184917 28.316376,44.267719 27.215313,40.149494
          C25.895639,35.213615 29.459593,33.007141 33.038265,30.990009
          C35.715645,29.480896 38.773857,28.396235 39.860451,25.090317
          C38.889141,23.617815 37.581696,23.538364 36.237644,23.421370
          C31.743235,23.030149 27.778772,26.369234 23.697502,26.041334
          C13.766644,25.243462 11.079930,31.298573 9.449570,39.044392
          C9.142760,40.502033 8.620502,41.912918 8.257411,43.360371
          C6.799964,49.170444 6.518748,54.714058 10.412361,59.965836
          C14.064775,64.892281 17.087151,70.283081 20.685883,75.252960
          C23.547651,79.205086 27.145903,82.424904 32.213589,83.404213
          C34.168739,83.782043 35.946770,83.412292 37.024124,81.645676
          C38.051628,79.960793 36.551502,78.922340 35.687893,77.748863
          C34.700542,76.407257 32.756668,75.514511 33.289818,73.234161
          C36.185467,74.146896 36.185467,74.146896 38.793327,76.680412
        M81.032074,58.424847
          C90.688728,53.593960 92.633995,48.897224 89.249535,38.652218
          C88.676834,36.918625 88.023407,35.188843 87.686714,33.404572
          C86.801521,28.713581 83.863380,26.515160 79.304581,26.467571
          C76.108383,26.434208 72.976768,26.202423 69.995598,25.040543
          C62.726486,22.207476 55.169544,23.711592 47.730728,23.512367
          C46.006592,23.466192 44.582039,24.538153 43.366318,25.720407
          C40.036972,28.958105 36.991211,32.477554 32.580669,34.459789
          C30.693756,35.307823 29.578070,37.172215 30.178890,39.453121
          C30.790798,41.776119 32.711044,42.371372 34.802578,42.547031
          C38.955959,42.895847 42.672703,41.319405 46.263893,39.595146
          C48.936466,38.311954 50.953094,38.739616 53.017761,40.723824
          C58.767281,46.249271 64.867714,51.437733 70.302895,57.251637
          C73.611740,60.791042 76.463348,61.930176 81.032074,58.424847 Z
      '
		/>
	</SvgIcon>
);
